import type { OrderOverlayTab } from '../types';

export const classes = {
  wrapper: 'h-screen grow min-w-[350px] overflow-x-auto px-3',
  buttonsWrapper:
    'absolute top-0 right-0 mx-2 mt-1 mb-2 z-10 flex items-center',
  icon: 'text-grey-7 dark:text-mauve-2',
  tabsBlock: 'w-full flex flex-col flex-1 h-full',
  tabBody: 'flex-1 min-h-0 overflow-auto',
};

export function getDefaultTab(searchParams: URLSearchParams): OrderOverlayTab {
  // TODO: This is probably overkill if there's only one tab
  let overlayTab = searchParams.get('orderOverlayTab');
  if (!overlayTab || !['overview'].includes(overlayTab)) {
    overlayTab = 'overview';
  }
  return overlayTab as OrderOverlayTab;
}
